import React from 'react';
import styles from './Dropdown.List.scss';
export var DropdownList = function DropdownList(props) {
  return React.createElement("ul", {
    className: styles.dropdownList
  }, props.children);
};